const MARKET_ORIGIN = 'https://www.locs.club';

export const LEGAL_URLS = {
  communityGuidelines: `${MARKET_ORIGIN}/community-guidelines`,
  childSafety: `${MARKET_ORIGIN}/child-safety`,
  privacyPolicy: `${MARKET_ORIGIN}/privacy`,
  termsOfService: `${MARKET_ORIGIN}/terms`,
  safetyCenter: `${MARKET_ORIGIN}/safety`
} as const;

export const LEGAL_LINKS = [
  { label: '社区准则', href: LEGAL_URLS.communityGuidelines },
  { label: '儿童安全', href: LEGAL_URLS.childSafety },
  { label: '隐私', href: LEGAL_URLS.privacyPolicy },
  { label: '条款', href: LEGAL_URLS.termsOfService },
  { label: '安全中心', href: LEGAL_URLS.safetyCenter }
] as const;
